export const environment = {
  production: false,
  API_URL: 'https://helios-dev-ecs.zippmat.app',

  SHARE_URL: 'https://rfq-dev.getprice.in',
};
